import { useKindeAuth } from '@kinde-oss/kinde-auth-react'
import {
  Box,
  Button,
  Divider,
  Drawer,
  IconButton,
  ListItemButton,
  ListItemIcon,
  ListItemText
} from '@mui/material'
import { AuthorizationButton } from 'components/Auth/AuthorizationButton'
import { Loader } from 'components/Loader'
import { Navigation } from 'components/Navigation'
import { X } from 'lucide-react'
import React, { useEffect, useState } from 'react'
import { useWpAuthContext } from 'services/auth/WpAuthProvider'

interface BurgerMenuProps {
  toggleDrawer: () => void
  open: boolean
}

export const BurgerMenu: React.FC<BurgerMenuProps> = ({
  toggleDrawer,
  open
}) => {
  const { isAuthenticated, isLoading } = useKindeAuth()
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const { authUser } = useWpAuthContext()

  useEffect(() => {
    if (isAuthenticated && !authUser) {
      setIsLoggedIn(true)
    } else {
      setIsLoggedIn(false)
    }
  }, [isAuthenticated, authUser])
  return (
    <Drawer anchor="right" open={open} onClose={toggleDrawer}>
      <Box
        sx={{
          px: 1,
          py: 2,
          height: 1,
          backgroundColor: 'var(--white)'
        }}
      >
        {/* when clicking the icon it calls the function toggleDrawer and closes the drawer by setting the variable open to false */}
        <IconButton sx={{ mb: 2 }} onClick={toggleDrawer}>
          <X />
        </IconButton>

        <Divider sx={{ mb: 2 }} />

        <Box sx={{ mb: 2, px: 5 }}>
          <Navigation mobile mode="dark" />
        </Box>
        <Divider sx={{ mb: 2 }} />

        <Box display={'flex'} justifyContent={'center'} position={'relative'}>
          <AuthorizationButton
            type={isAuthenticated && !isLoggedIn ? 'logout' : 'login'}
            mode={'dark'}
            className="header"
          />
        </Box>
      </Box>
    </Drawer>
  )
}
